import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { navigationService } from 'src/config/rootService';
import { Button } from 'src/shared/components/Button';
import * as HeaderStyles from 'src/shared/layout/styles';
import { color, font } from 'src/shared/styles/variables';

import img from 'src/public/img/account-expired.svg';
import logo from 'src/public/img/mh-icon.svg';

const HeaderOuterWrapper = styled.div({
    padding: '1.2rem',
    borderBottom: `2px solid #fafafa`,
});

const HeaderInnerWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 1920,
    margin: '0 auto',
});

const CloseButton = styled.button({
    border: 'none',
    backgroundColor: color.white,
    color: color.blueBayoux,
    ...font.medium(font.size.medium),
});

const ContentWrapper = styled.div({
    padding: '1rem',
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
});

const HeadingText = styled.h2(
    {
        marginTop: '1rem',
        color: color.pickledBluewood,
    },
    font.heavy(font.size.header),
);

const SecondaryText = styled.p(
    {
        color: color.steelGray,
        marginBottom: '2.5rem',
    },
    font.medium(font.size.medium),
);

const DescriptionText = styled(SecondaryText)({
    maxWidth: 600,
    marginBottom: '1.5rem',
});

const HighlightedText = styled.a(
    {
        color: color.royalBlue,
    },
    font.heavy(font.size.medium),
);

const AccountHasExpired: React.FC = () => {
    const navigateToHomepage = (e?) => {
        if (e) {
            e.preventDefault();
        }

        navigationService.navigate('/');
    };
    const { t } = useTranslation();

    return (
        <div>
            <HeaderOuterWrapper>
                <HeaderInnerWrapper>
                    <HeaderStyles.BrandWrapper>
                        <HeaderStyles.BrandLogoAnchor href="/" onClick={navigateToHomepage}>
                            <HeaderStyles.BrandLogoImage src={logo} alt="brand logo" />
                            <HeaderStyles.BrandName blueVariant>
                                {t('auth:expired_account.brand_name')}
                            </HeaderStyles.BrandName>
                        </HeaderStyles.BrandLogoAnchor>
                    </HeaderStyles.BrandWrapper>

                    <CloseButton onClick={navigateToHomepage}>{t('common.close')}</CloseButton>
                </HeaderInnerWrapper>
            </HeaderOuterWrapper>

            <ContentWrapper>
                <img src={img} />

                <HeadingText>{t('auth:expired_account.your_account_has_expired')}</HeadingText>
                <DescriptionText>
                    {t('auth:expired_account.expiration_description')}
                </DescriptionText>
                <SecondaryText>
                    {t('auth:expired_account.please_contact')}{' '}
                    <HighlightedText href="mailto:help@joinmodernhealth.com">
                        help@joinmodernhealth.com
                    </HighlightedText>{' '}
                    {t('auth:expired_account.please_contact_ending')}
                </SecondaryText>

                <Button onClick={navigateToHomepage} type="accept" withShadow>
                    {t('auth:expired_account.back_to_homepage')}
                </Button>
            </ContentWrapper>
        </div>
    );
};

export default AccountHasExpired;
